'use strict';

import Utilities from './../Utilities/Utilities.js';
import jQuery from 'jquery';
import cookie from './../../vendor/jquery.cookie';
import ga from './../../vendor/google-analytics';
import Search from './Search.js';

import flag from './../Feature/Feature';
import Subnav from './Subnav';

var Header = (function ($) {
  return function (options) {

    // Namespace for private variables and functions
    var privateNS = {
      defaults: { // Namespace for default options
      }
    };

    // Namespace for public variables and functions
    var publicNS = {};

    /**
     * Construct a new instance
     */
    privateNS.init = function init() {

      // Create a reference to the window
      privateNS.$window = $(window);

      // Create a reference to the html element where all events will propagate
      // to by default
      privateNS.$html = $('html');

      // Create a reference to the main body tag
      privateNS.$body = $('body');

      // Create a reference to the main header
      privateNS.$header = $('#main-header');

      // Create a reference to the body wrapper
      privateNS.$bodyWrapper = $('#body-wrapper');

      // Create a reference to the main header sticky wrapper
      privateNS.$mainHeaderWrapper = $('#main-header-wrapper');

      // The first child of the #body-wrapper.  Used for getting the height with the slant.
      privateNS.$bodyWrapperFirstChild = $('#body-wrapper *:first-child');

      // Create a reference to the flyout menu and the flyout menu trigger
      privateNS.$headerFlyout = $('.header-flyout');
      privateNS.$headerFlyoutTrigger = $('.header-flyout-trigger');

      // Create a reference to the sub-navigation elements in the flyout
      privateNS.$headerFlyoutSubnav = privateNS.$headerFlyout.find('.sub-navigation-parent');

      // Create a reference to the extra social icons
      privateNS.$headerSocialExtra = $('.flyout-social-extra');

      // Create a reference to the search flyout and search flyout trigger
      privateNS.$headerSearchFlyout = $('.header-search-flyout');
      privateNS.$headerSearchFlyoutTrigger = $('.header-search-flyout-trigger');

      // Create a reference to the sign in button
      privateNS.$signIn = privateNS.$header.find('.sign-in');

      // Create a new subnav module
      privateNS.subnav = Subnav;

      // Attach event handlers
      privateNS.attachHandlers();

      // Return the public namespace
      return publicNS;
    };

    /**
     * Handles the event triggered by clicking on the main menu
     * flyout icon. First hide the search flyout if it is
     * currently open, and second toggle the main menu flyout
     *
     * @param event event The triggering event
     */
    privateNS.onHeaderFlyoutTriggerClick = function onHeaderFlyoutTriggerClick(event) {

      // Hide the search flyout if it is currently visible
      publicNS.toggleHeaderSearchFlyout(false);

      // Toggle the state of the main menu flyout
      publicNS.toggleHeaderFlyout(privateNS.$headerFlyout.hasClass('hide'));
    };

    /**
     * Changes the main menu flyout to the specified state.
     * True displays the flyout, false hides it.
     *
     * @param state boolean The state to change the main menu flyout to
     */
    publicNS.toggleHeaderFlyout = function toggleHeaderFlyout(state) {

      // Toggle the visibility state of the flyout navigation
      privateNS.$headerFlyout.toggleClass('hide', !state);

      // Toggle the accessibility indication of an open menu
      privateNS.$headerFlyoutTrigger.attr('aria-expanded', state);

      // Toggle the state of the header flyout trigger
      privateNS.$headerFlyoutTrigger.toggleClass('active', state);

      // Toggle the scroll preventing class on the body so it does not
      // scroll while the menu scrolls
      privateNS.$body.toggleClass('header-flyout-cancel-scroll', state);

      // Handle cases where the flyout menu overflows beyond the full height
      // of the screen
      privateNS.handleFlyoutOverflow(state);

      // If the flyout is being shown then bind a listener for clicks outside
      // of the flyout
      if (state) {

        privateNS.$headerFlyout.find('a').each(function () {
          $(this).attr('tabindex', '1');
        });

        // Perform the add listener asynchronously so it does not mistakenly
        // get triggered by the event that adds it
        setTimeout(function () {

          // Bind the listener for clicks that reach the top of the DOM
          privateNS.$html.on(
            'click',
            privateNS.hideFlyout
          );

          // If escape key is pressed, close the flyout
          privateNS.$html.on(
            'keydown',
            privateNS.handleFlyoutKeyPress
          )
        }, 0);
      } else {

        privateNS.$headerFlyout.find('a').each(function () {
          $(this).attr('tabindex', '-1');
        });

        // Otherwise remove the listener as it is no longer needed
        privateNS.$html.off('click', privateNS.hideFlyout);
        privateNS.$html.off('keydown', privateNS.handleFlyoutKeyPress);
      }
    };

    privateNS.handleFlyoutOverflow = function handleFlyoutOverflow(state) {

      // Calculate the height of the expanded header combined with the sticky
      // header
      var flyoutHeaderHeight = publicNS.getHeight() + privateNS.$headerFlyout.outerHeight(),
        isMenuLargerThanScreen = $(window).height() <= flyoutHeaderHeight;

      // Add an override class to require menu scrolling
      privateNS.$body.toggleClass('header-flyout-height-overflow', state && isMenuLargerThanScreen);
    };

    /**
     * Hides the main menu flyout
     */
    privateNS.hideFlyout = function hideFlyout() {

      // Toggle the flyout to hidden
      publicNS.toggleHeaderFlyout(false);
    };

    /**
     * Handles the event triggered by clicking on the search icon
     * on small devices. First hide the main menu flyout if it
     * is currently open, and second toggle the display of the
     * search bar flyout
     *
     * @param event event The triggering event
     */
    privateNS.onSearchFlyoutTriggerClick = function onSearchFlyoutTriggerClick(event) {

      // Prevent the search button from going to another page
      event.preventDefault();

      // Hide the main flyout menu if it is currently visible
      publicNS.toggleHeaderFlyout(false);

      // Toggle the state of the search trigger and flyout
      publicNS.toggleHeaderSearchFlyout(!privateNS.$headerSearchFlyoutTrigger.hasClass('search-active'));
    };


    /**
     * Accessibility: Adds a keypress to the window to close the flyout menu
     * upon pressing the esc key.
     *
     * @param event event The triggering event
     */
    privateNS.handleFlyoutKeyPress = function handleFlyoutKeyPress(event) {
      if (event.keyCode === 27) {
        event.stopPropagation;
        privateNS.hideFlyout();
      }
    };

    /**
     * Changes the search flyout to the specified state.
     * True displays the search flyout and changes the triggering
     * icon to an active state. False hides the search flyout
     * and changes the triggering icon to an inactive state.
     *
     * @param state boolean The state to change the search flyout to
     */
    publicNS.toggleHeaderSearchFlyout = function toggleHeaderSearchFlyout(state) {

      // Toggle the trigger display class for the search flyout being active
      privateNS.$headerSearchFlyoutTrigger.toggleClass('search-active', state);

      // Toggle the visibility of the flyout search element
      privateNS.$headerSearchFlyout.toggleClass('hide', !state);

      // Toggle the accessibility indication of an open menu
      privateNS.$headerSearchFlyoutTrigger.attr('aria-expanded', state);

      // If the flyout is being shown then bind a listener for clicks outside
      // of the flyout
      if (state) {

        // Perform the add listener asynchronously so it does not mistakenly
        // get triggered by the event that adds it
        setTimeout(function () {

          // Bind the listener for clicks that reach the top of the DOM
          privateNS.$html.on(
            'click',
            privateNS.hideSearchFlyout
          );

          // If escape key is pressed, close the flyout
          privateNS.$html.on(
            'keydown',
            privateNS.handleSearchFlyoutKeyPress
          )
        }, 0);
      } else {

        // Otherwise remove the listener as it is no longer needed
        privateNS.$html.off('click', privateNS.hideSearchFlyout);
        privateNS.$html.off('keydown', privateNS.handleSearchFlyoutKeyPress);
      }
    };

    /**
     * Hides the search flyout
     */
    privateNS.hideSearchFlyout = function hideSearchFlyout() {

      // Toggle the flyout to hidden
      publicNS.toggleHeaderSearchFlyout(false);
    };

    /**
     * Handles clicks on the sub navigation parent elements. Toggles the active
     * state of the clicked navigation parent and toggles the state of the
     * sub navigation menu that is associated with the parent element.
     *
     * @param event Event The triggering event
     */
    privateNS.onSubnavParentClick = function onSubnavParentClick(event) {
      // Prevent the default action of the url so that the subnav is shown
      event.preventDefault();

      // Extract the id of the sub nav to toggle from the clicked target,
      // and get a reference to the corresponding sub navigation
      // Use $(this) to consistently get a reference to the anchor tag
      // that the event is bound to
      var $target = $(event.target),
        $listItemParent = $target.parents('.flyout-navigation-item'),
        subnavId = $listItemParent.find('.sub-navigation-parent').attr('data-subnav'),
        $subnav = $('#' + subnavId);

      // If now active, set accessibility attribute
      $target.attr("aria-expanded") == "true" ? $target.attr("aria-expanded", "false") : $target.attr("aria-expanded", "true");

      // Toggle the display state of the subnav
      $subnav.toggleClass('hide');

      // Toggle the active state marker on the target
      $listItemParent.toggleClass('active');

      // Handle the height increase in the case that the header grows too large
      privateNS.handleFlyoutOverflow(true);
    };

    /**
     * Handles keyboard navigation on the sub navigation parent elements. Toggles the active
     * state of the clicked navigation parent and toggles the state of the
     * sub navigation menu that is associated with the parent element.
     *
     * @param event Event The triggering event
     */
    privateNS.onSubnavParentKeyPress = function onSubnavParentKeyPress(event) {
      if (event.keyCode === 13 || event.keyCode === 32) {
        privateNS.onSubnavParentClick(event);
      }
    };

    /**
     * Handles the click events on the subscribe button of the flyout menu.
     * First triggers a tracking event, and then displays the modal
     * signup form
     *
     * @param event Event The triggering event
     */
    privateNS.onClickSignup = function onClickSignup(event) {

      // Track the click event back to Google Analytics
      ga('send', 'event', 'newsletter', 'Header eNews click');
    };

    /**
     * Handles the click events on the a11y skip link.
     * First triggers a tracking event, and then moves focus to main content
     *
     * @param event Event The triggering event
     */
    privateNS.onClickSkipLink = function onClickSkipLink(event) {
      event.preventDefault();

      // Track the click event back to Google Analytics
      ga('send', 'event', 'accessibility', 'Skip Link click');

      // strip the leading hash and declare
      // the content we're skipping to
      var skipTo = "#" + this.href.split('#')[1];

      // Setting 'tabindex' to -1 takes an element out of normal
      // tab flow but allows it to be focused via javascript
      $(skipTo).attr('tabindex', -1).on('blur focusout', function () {

        // when focus leaves this element,
        // remove the tabindex attribute
        $(this).removeAttr('tabindex');

      }).focus(); // focus on the content container
    };

    /**
     * Handles the click of the menu icon
     *
     * @param event Event The triggering event
     */
    privateNS.onClickMenu = function onClickEvents(event) {
      if ($(event.currentTarget).hasClass('active')) {
        ga('send', 'event', 'hamburger', 'Stacked lines click', Utilities.buildTrackingURL($('head').attr('data-tracking')));
      }
    };

    /**
     * Handles clicks on the sign in text in the header. Stores the location of
     * the user for later use
     *
     * @param {jQuery} $event The triggering jQuery event
     */
    privateNS.onClickSignIn = function onClickSignIn($event) {

      // Update the last known location of the user before they enter sign in land
      $.cookie('location_before_signin', window.location, { path: '/' });

      // TODO: Do some kind of ga tracking here
    };

    /**
     * Handles the event triggered by clicking on the more social
     * media services icon. Toggles between the open / close
     * icons for the triggering icon. Toggles the display of the
     * visibility of the extra social media icons.
     *
     * @param event event The triggering event
     */
    publicNS.toggleHeaderSocialExtra = function toggleHeaderSocialExtra(event) {

      // Prevent the more button from reloading the page
      event.preventDefault();

      // Grab a reference to the jQuery clicked element, and the
      // display icons for the elements
      var $jTarget = $(this), // .flyout-social-more
        $moreIcons = $jTarget.find('.fa-plus, .fa-minus');

      // Toggle the visibility states of the plus and minus icons
      $moreIcons.toggleClass('hide');

      // Toggle the visibility state of the extra social icons in the header
      privateNS.$headerSocialExtra.toggleClass('hide');
    };

    /**
     * Accessibility: Adds a keypress to the window to close the flyout menus
     * upon pressing the esc key.
     *
     * @param event event The triggering event
     */
    privateNS.handleWindowKeyPress = function handleWindowKeyPress(event) {
      if (event.keyCode === 27) {
        if (privateNS.$headerSearchFlyoutTrigger.hasClass('search-active')) {
          privateNS.hideSearchFlyout();
        }

      }
    };

    /**
     * Accessibility: Adds a keypress to the window to close the search flyout menu
     * upon pressing the esc key.
     *
     * @param event event The triggering event
     */
    privateNS.handleSearchFlyoutKeyPress = function handleSearchFlyoutKeyPress(event) {
      if (event.keyCode === 27) {
        event.stopPropagation;
        privateNS.hideSearchFlyout();
      }
    };

    /**
     * Accessor for retrieving the height taken up by the header
     *
     * @returns int The height of the header
     */
    publicNS.getHeight = function getHeight() {
      return privateNS.$mainHeaderWrapper.outerHeight();
    };

    /**
     * Gets the height of the sub-ehader.  If there is no sub-header it just returns 0.
     */
    publicNS.getSubHeaderHeight = function getSubHeaderHeight() {
      return privateNS.subnav.getHeight();
    };

    /**
     * Gets the height with the slant.
     *
     * @return float
     */
    publicNS.getHeightWithSlant = function getHeightWithSlant() {
      return privateNS.$bodyWrapperFirstChild.offset().top;
    };

    /**
     * Attach the event handlers for the header triggers
     */
    privateNS.attachHandlers = function attachHandlers() {

      // Attach the flyout menu toggle event handler
      privateNS.$header.on(
        'click',
        '.header-flyout-trigger',
        privateNS.onHeaderFlyoutTriggerClick
      );

      // Attach the search flyout event handler
      privateNS.$header.on(
        'click',
        '.header-search-flyout-trigger',
        privateNS.onSearchFlyoutTriggerClick
      );

      // Attach the sub navigation toggle event handlers
      privateNS.$headerFlyoutSubnav.on(
        'click',
        privateNS.onSubnavParentClick
      );

      // Attach the sub navigation toggle event handlers
      privateNS.$headerFlyoutSubnav.on(
        'keydown',
        privateNS.onSubnavParentKeyPress
      );

      // Prevent any clicks in the flyout menu from propagating up from it
      privateNS.$headerFlyout.on(
        'click',
        function trapFlyoutClicks(event) {

          // Stop the propagation
          event.stopPropagation();
        }
      );

      // Prevent any clicks in the search flyout menu from propagating up from it
      privateNS.$headerSearchFlyout.on(
        'click',
        function trapFlyoutClicks(event) {

          // Stop the propagation
          event.stopPropagation();
        }
      );

      // Bind a noop to the touch start event on sub nav elements to
      // make sure the :active state is shown on mobile
      privateNS.$mainHeaderWrapper.on(
        'touchstart',
        '.sub-navigation-parent',
        function noop() {
        }
      );

      // Attach the events event handler
      privateNS.$header.on(
        'click',
        '.header-flyout-trigger',
        privateNS.onClickMenu
      );

      // Attach the eNews subscribe event handler
      privateNS.$mainHeaderWrapper.on(
        'click',
        '.email-signup-call-to-action',
        privateNS.onClickSignup
      );

      // Attach the eNews subscribe event handler
      privateNS.$mainHeaderWrapper.on(
        'click',
        '.skip-link',
        privateNS.onClickSkipLink
      );

      // Handle clicks on the sign in button in the header
      privateNS.$signIn.on(
        'click',
        privateNS.onClickSignIn
      );

      $('.watch-link').click(function (e) {
        ga('send', 'event', 'Navigation', 'Click header link', 'Watch Live');
      });

      // Handler for mobile sub-nav.
      $('.mobile-sub-nav').click(function (e) {
        $('.mobile-sub-nav, .sub-navigation').toggleClass('active');

        e.preventDefault();
      });
    };

    // Return a new instance
    return privateNS.init();
  };

})(jQuery);

export default new Header()